module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-5-eb78f696f481d01d8b70e114b695c8af.jpg";